module.exports = __webpack_public_path__ + "img/jamesc-profile-pic.0d52d3b5.png";